import { motion } from "framer-motion";

const items = [
  {
    quote:
      "They brought our vision to life with creativity, precision, and effortless professionalism.",
    name: "Hari Constructions",
    role: "Brand Partner",
  },
  {
    quote:
      "An exceptional team whose insight and meticulous execution elevated our brand with sophistication and purpose.",
    name: "Mugdha HR",
    role: "Client",
  },
  {
    quote:
      "An incredibly talented team that made the entire branding journey effortless. Their creativity and attention to detail exceeded our expectations.",
    name: "Kariyatri",
    role: "Founder",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#140e0a] py-32 md:py-48"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mb-16 md:mb-24">
          <p className="overline">
            <span className="text-[#d99036]">✦</span>&nbsp;&nbsp;Notes from the room
          </p>
          <h2 className="mt-6 max-w-[900px] font-display text-5xl font-black leading-[0.95] tracking-tight md:text-7xl">
            Words from
            <br />
            <span className="font-serif-editorial italic font-normal text-[#d99036]">
              the people we build with.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
          {items.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="relative flex h-full flex-col justify-between border border-[#2a1f17] bg-[#0a0705] p-8 md:p-10"
            >
              <span
                aria-hidden
                className="absolute -top-6 left-6 font-serif-editorial text-8xl italic leading-none text-[#d99036]"
              >
                &ldquo;
              </span>
              <blockquote className="font-serif-editorial text-2xl leading-[1.35] text-[#f2ebdd] md:text-[26px]">
                {t.quote}
              </blockquote>
              <figcaption className="mt-10 border-t border-[#2a1f17] pt-6">
                <p className="font-display text-sm font-bold uppercase tracking-[0.22em] text-[#f9f6f0]">
                  {t.name}
                </p>
                <p className="mt-1 overline">{t.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <p className="mt-10 font-body text-[11px] uppercase tracking-[0.24em] text-[#a89f91]/60">
          * Placeholder quotes shown while final client statements are being sourced.
        </p>
      </div>
    </section>
  );
}
